import { FC, useMemo } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Typography } from "@mui/material";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";

interface SavingsOpportunityMonthlySavingsGroupCell {
  node: CustomCellRendererProps<SavingsOpportunity>["node"];
}

export const SavingsOpportunityMonthlySavingsGroupCell: FC<
  SavingsOpportunityMonthlySavingsGroupCell
> = ({ node }) => {
  const totalSavings = useMemo(() => {
    const children = node.allLeafChildren ?? [];
    return children.reduce((sum, child) => {
      const rowData = child.data as SavingsOpportunity;
      return sum + (rowData?.monthly_savings ?? 0);
    }, 0);
  }, [node]);

  return (
    <Typography variant="body2" color="success.light">
      {money(totalSavings ?? 0)}
    </Typography>
  );
};
